import { IResult } from "../interface"
import { createAxiosHttp } from "./createHttpRequest"

// 聊天常用语
export type CustomFormTemplatesResult = {
  code: number
  message: string
  data: {
    code: string
    createTime: string
    id: number
    inputState: number
    name: string
    serial: number
    type: number
    version: string
    visitId: number
  }[]
}
export const getCustomFormTemplates = (visitId: number)=> {
  return createAxiosHttp<CustomFormTemplatesResult>({
    url: `data/visit/customize/${visitId}`
  })
}